import { useCallback } from 'react';
import MeasurementLayer from '../../layers/MeasurementLayer';
import LayerCheckbox from './LayerCheckbox';
import { useProject } from '@contexts/Project.context';

const MEASUREMENT_DIALOGUE_CONFIG = {
	header: 'Measurement Layer Added',
	instruction: 'Use the draw tools in the bottom toolbar.',
	warning:
		'Note: The Measurement Layer is temporary and will not be saved. Any sketches made here will be lost if you refresh the page or remove the layer.',
	fullWidth: false,
	autoClose: true,
	dismissible: true,
};

/**
 * MeasurementSection Component
 *
 * Renders a checkbox to add/remove the measurement layer.
 * When checked, displays the MeasurementLayer component with drawing tools.
 * Shows a dialogue with instructions when the layer is first added.
 *
 * @returns {JSX.Element} Checkbox or MeasurementLayer based on state
 */
const MeasurementSection = () => {
	const { measurementLayerAdded, dispatch } = useProject();

	const handleAddMeasurementLayer = useCallback(() => {
		dispatch({
			type: 'setMeasurementLayerAdded',
			payload: true,
		});
		dispatch({
			type: 'setDialogue',
			payload: {
				header: MEASUREMENT_DIALOGUE_CONFIG.header,
				body: (
					<>
						<p>{MEASUREMENT_DIALOGUE_CONFIG.instruction}</p>
						<p>{MEASUREMENT_DIALOGUE_CONFIG.warning}</p>
					</>
				),
				fullWidth: MEASUREMENT_DIALOGUE_CONFIG.fullWidth,
				autoClose: MEASUREMENT_DIALOGUE_CONFIG.autoClose,
				dismissible: MEASUREMENT_DIALOGUE_CONFIG.dismissible,
			},
		});
	}, [dispatch]);

	if (measurementLayerAdded) {
		return <MeasurementLayer />;
	}

	return (
		<li>
			<LayerCheckbox
				id="add-measurement-layer"
				label="Measurements"
				defaultChecked={false}
				onCheck={handleAddMeasurementLayer}
			/>
		</li>
	);
};

export default MeasurementSection;
